export class AxiosConfig {
  static API_SERVER: string
}
